<template>
  <div class="administrador mt-4">
    <div class="row m-0">
      <div class="col-lg-3 col-md-3 col-sm-12 p-0 bg-gray-1">
        <div class="menu-area-restrita mb-4">
          <ul id="meus-dados" class="slide-nav">
            <li class="item"><i class="fas fa-bars"></i> Meus Dados</li>
            <transition name="slide">
              <ul class="child" v-if="isSlowDados">
                <li class="sub-item">
                  <router-link
                    class="dropdown-sub-item fs-12"
                    :to="{ name: 'administrador-meus-dados' }"
                    >Meus dados</router-link
                  >
                </li>
                <li class="sub-item mb-3">
                  <router-link
                    class="dropdown-sub-item fs-12"
                    :to="{ name: 'sair' }"
                  >
                    Sair
                  </router-link>
                </li>
              </ul>
            </transition>
          </ul>

          <ul
            v-if="checkPermission('usuarios')"
            id="usuarios"
            class="slide-nav"
          >
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.users.open = !menu.users.open">
                <i class="fas fa-users mr-2"></i>
                <span class="d-none d-sm-inline">Usuários</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [!menu.users.open ? 'fa-chevron-right' : 'fa-chevron-down']
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.users.open">
                  <ul class="flex-column ml-3 nav">
                    <li
                      v-if="checkPermission('usuarios', 'clientes')"
                      class="sub-item font-weight-bold"
                    >
                      <router-link
                        class="dropdown-sub-item fs-12"
                        :to="{ name: 'administrador-clientes' }"
                        >&#9679; Clientes</router-link
                      >
                    </li>
                    <li
                      v-if="checkPermission('usuarios', 'profissionais')"
                      class="sub-item"
                    >
                      <router-link
                        class="dropdown-sub-item fs-12 font-weight-bold"
                        :to="{ name: 'administrador-profissionais' }"
                        >&#9679; Profissionais</router-link
                      >
                      <ul class="slide-nav u-sub">
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{
                              name: 'administrador-profissionais-gratuito',
                            }"
                            >- Gratuito</router-link
                          >
                        </li>
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{ name: 'administrador-profissionais-bronze' }"
                            >- Bronze</router-link
                          >
                        </li>
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{ name: 'administrador-profissionais-prata' }"
                            >- Prata</router-link
                          >
                        </li>
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{ name: 'administrador-profissionais-ouro' }"
                            >- Ouro</router-link
                          >
                        </li>
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{
                              name: 'administrador-profissionais-diamante',
                            }"
                            >- Diamante</router-link
                          >
                        </li>
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{
                              name: 'administrador-profissionais-indicados',
                            }"
                          >
                            - Indicados
                          </router-link>
                        </li>
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{
                              name: 'administrador-profissionais-denuncias',
                            }"
                          >
                            - Denuncias
                          </router-link>
                        </li>
                      </ul>
                    </li>

                    <li
                      v-if="checkPermission('usuarios', 'lojistas')"
                      class="sub-item"
                    >
                      <router-link
                        class="dropdown-sub-item fs-12 font-weight-bold"
                        :to="{ name: 'administrador-lojistas' }"
                        >&#9679; Lojistas</router-link
                      >
                    </li>
                    <li
                      v-if="checkPermission('usuarios', 'representantes')"
                      class="sub-item"
                    >
                      <router-link
                        class="dropdown-sub-item fs-12 font-weight-bold"
                        :to="{ name: 'administrador-representantes' }"
                        >&#9679; Representantes</router-link
                      >
                    </li>
                    <li
                      v-if="checkPermission('usuarios', 'parceiros')"
                      class="sub-item"
                    >
                      <router-link
                        class="dropdown-sub-item fs-12 font-weight-bold"
                        :to="{ name: 'administrador-parceiros' }"
                        >&#9679; Parceiros</router-link
                      >
                      <ul class="slide-nav u-sub">
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{ name: 'lojistas-por-link' }"
                          >
                            - Lojistas vindos por link
                          </router-link>
                        </li>
                      </ul>
                    </li>

                    <li
                      v-if="checkPermission('usuarios', 'gerente-contas')"
                      class="sub-item"
                    >
                      <router-link
                        class="dropdown-sub-item fs-12 font-weight-bold"
                        :to="{ name: 'administrador-gerente-vendas' }"
                      >
                        &#9679; Gerente de conta
                      </router-link>

                      <ul class="slide-nav u-sub">
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{
                              name: 'administrador-gerente-recomendacoes',
                            }"
                          >
                            - Pedidos de Recomendações
                          </router-link>
                        </li>
                      </ul>
                    </li>

                    <li
                      v-if="checkPermission('usuarios', 'parceiros')"
                      class="sub-item"
                    >
                      <router-link
                        class="dropdown-sub-item fs-12 font-weight-bold"
                        :to="{ name: 'administrador-parceiros-externos' }"
                        >&#9679; Parceiros Externos
                      </router-link>
                    </li>
                    <li
                      v-if="checkPermission('usuarios', 'afiliados')"
                      class="sub-item"
                    >
                      <router-link
                        class="dropdown-sub-item fs-12 font-weight-bold"
                        :to="{ name: 'administrador-afiliados' }"
                      >
                        &#9679; Afiliados
                      </router-link>
                      <ul class="slide-nav u-sub">
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{
                              name: 'administrador-afiliados-nao-avaliados',
                            }"
                          >
                            - Afiliados não avaliados
                          </router-link>
                        </li>
                        <li class="sub-item">
                          <router-link
                            class="dropdown-sub-item fs-12"
                            :to="{ name: 'administrador-afiliado-boletos' }"
                          >
                            - Boletos Pendentes
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('planos')" id="planos" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.plans.open = !menu.plans.open">
                <i class="fas fa-medal mr-2"></i>
                <span class="d-none d-sm-inline">Planos</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [!menu.plans.open ? 'fa-chevron-right' : 'fa-chevron-down']
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.plans.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-planos-profissionais' }"
                      >&#9679; Profissionais</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-assinatura-planos-app' }"
                      >&#9679; Planos de assinatura app/site</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cupons-planos' }"
                      >&#9679; Cupons</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{
                        name: 'administrador-assinatura-planos-profissional',
                      }"
                      >&#9679; Planos de assinatura profissional</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-planos-redes-sociais' }"
                      >&#9679; Artes redes sociais</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-upload-plano' }"
                      >&#9679; Upload imagens plano</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('banners')" id="banners" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.banners.open = !menu.banners.open">
                <i class="fas fa-bookmark mr-2"></i>
                <span class="d-none d-sm-inline">Banners</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.banners.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.banners.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-edita-banners' }"
                      >&#9679; Criar</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-lista-banners' }"
                      >&#9679; Listar</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('medidas')" id="medidas" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.measures.open = !menu.measures.open">
                <i class="fas fa-ruler mr-2"></i>
                <span class="d-none d-sm-inline">Medidas</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.measures.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.measures.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cria-medidas' }"
                      >&#9679; Criar</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-lista-medidas' }"
                      >&#9679; Listar</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('estados')" id="estados" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.states.open = !menu.states.open">
                <i class="fas fa-flag-usa mr-2"></i>
                <span class="d-none d-sm-inline">Estados</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [!menu.states.open ? 'fa-chevron-right' : 'fa-chevron-down']
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.states.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cria-estados' }"
                      >&#9679; Criar</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-lista-estados' }"
                      >&#9679; Listar</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('cidades')" id="cidades" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.citys.open = !menu.citys.open">
                <i class="fas fa-city mr-2"></i>
                <span class="d-none d-sm-inline">Cidades</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [!menu.citys.open ? 'fa-chevron-right' : 'fa-chevron-down']
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.citys.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cria-cidades' }"
                      >&#9679; Criar</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-lista-cidades' }"
                      >&#9679; Listar</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul
            v-if="checkPermission('segmentos')"
            id="segmentos"
            class="slide-nav"
          >
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.segments.open = !menu.segments.open">
                <i class="fas fa-tags mr-2"></i>
                <span class="d-none d-sm-inline">Segmentos</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.segments.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.segments.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cria-segmentos' }"
                      >&#9679; Criar</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-lista-segmentos' }"
                      >&#9679; Listar</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul
            v-if="checkPermission('profissoes')"
            id="profissoes"
            class="slide-nav"
          >
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.professions.open = !menu.professions.open">
                <i class="fas fa-user-tie mr-2"></i>
                <span class="d-none d-sm-inline">Profissões</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.professions.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.professions.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cria-profissoes' }"
                      >&#9679; Criar</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-lista-profissoes' }"
                      >&#9679; Listar</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul
            v-if="checkPermission('produtos')"
            id="produtos"
            class="slide-nav"
          >
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.products.open = !menu.products.open">
                <i class="fas fa-shopping-cart mr-2"></i>
                <span class="d-none d-sm-inline">Produtos</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.products.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.products.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cria-produtos' }"
                      >&#9679; Criar</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-lista-produtos' }"
                      >&#9679; Listar</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('marcas')" id="marcas" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.brands.open = !menu.brands.open">
                <i class="fas fa-dollar-sign mr-2"></i>
                <span class="d-none d-sm-inline">Marcas</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [!menu.brands.open ? 'fa-chevron-right' : 'fa-chevron-down']
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.brands.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cria-produto-marca' }"
                      >&#9679; Criar</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-lista-produto-marca' }"
                      >&#9679; Listar</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('blog')" id="blog" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.blog.open = !menu.blog.open">
                <i class="fas fa-blog mr-2"></i>
                <span class="d-none d-sm-inline">Blog</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [!menu.blog.open ? 'fa-chevron-right' : 'fa-chevron-down']
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.blog.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cria-dicas' }"
                      >&#9679; Criar</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-lista-dicas' }"
                      >&#9679; Listar</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('pedidos')" id="pedidos" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.planorders.open = !menu.planorders.open">
                <i class="fas fa-box mr-2"></i>
                <span class="d-none d-sm-inline">Pedidos de Plano</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.planorders.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.planorders.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-ver-pedidos-contratos' }"
                      >&#9679; Ver</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul
            v-if="checkPermission('relatorios')"
            id="relatorios"
            class="slide-nav"
          >
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.reports.open = !menu.reports.open">
                <i class="fas fa-clipboard mr-2"></i>
                <span class="d-none d-sm-inline">Relatórios</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.reports.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.reports.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-ver-usuarios' }"
                      >&#9679; Dos Lojistas</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-ver-resultados' }"
                      >&#9679; Dos Resultados</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-ver-geral' }"
                      >&#9679; Do Geral</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul
            v-if="checkPermission('cotacoes')"
            id="cotacoes"
            class="slide-nav"
          >
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.quotes.open = !menu.quotes.open">
                <i class="fas fa-envelope-open-text mr-2"></i>
                <span class="d-none d-sm-inline">Cotações</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [!menu.quotes.open ? 'fa-chevron-right' : 'fa-chevron-down']
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.quotes.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cotacoes-geral' }"
                      >&#9679; Todas as Cotações</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-cotacoes-canceladas' }"
                      >&#9679; Cotações canceladas</router-link
                    >
                  </li>
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 ml-3"
                      :to="{ name: 'administrador-email-lojista' }"
                      >&#9679; Responder Cotações</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('ranking')" id="ranking" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.ranking.open = !menu.ranking.open">
                <i class="fas fa-trophy mr-2"></i>
                <span class="d-none d-sm-inline">Ranking Parceiros</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.ranking.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.ranking.open">
                  <ul class="flex-column ml-3 nav">
                    <li class="sub-item font-weight-bold">
                      <router-link
                        class="dropdown-sub-item fs-12"
                        :to="{ name: 'administrador-ranking-parceiros' }"
                        >&#9679; Ver e Editar</router-link
                      >
                    </li>
                  </ul>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('ranking')" id="ranking" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.ranking.open = !menu.ranking.open">
                <i class="fas fa-trophy mr-2"></i>
                <span class="d-none d-sm-inline"
                  >Ranking Parceiros Externos</span
                >
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.ranking.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.ranking.open">
                  <ul class="flex-column ml-3 nav">
                    <li class="sub-item font-weight-bold">
                      <router-link
                        class="dropdown-sub-item fs-12"
                        :to="{
                          name: 'administrador-ranking-parceiros-externos',
                        }"
                        >&#9679; Ver e Editar</router-link
                      >
                    </li>
                  </ul>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('videos')" id="videos" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.videos.open = !menu.videos.open">
                <i class="fas fa-video mr-2"></i>
                <span class="d-none d-sm-inline">Vídeos</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [!menu.videos.open ? 'fa-chevron-right' : 'fa-chevron-down']
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.videos.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 d-block ml-3"
                      :to="{ name: 'administrador-inicio-page' }"
                      >&#9679; Inicio</router-link
                    >
                    <router-link
                      class="dropdown-sub-item fs-12 d-block ml-3"
                      :to="{ name: 'administrador-participar-page' }"
                      >&#9679; Como Participar</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('imagens')" id="imagens" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.imagens.open = !menu.imagens.open">
                <i class="fas fa-image mr-2"></i>
                <span class="d-none d-sm-inline">Imagens</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.imagens.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.imagens.open">
                  <li class="sub-item">
                    <router-link
                      class="dropdown-sub-item fs-12 d-block ml-3 font-weight-bold"
                      :to="{ name: 'editar-imagens-categoria-app' }"
                      >&#9679; Categorias App</router-link
                    >
                    <router-link
                      class="dropdown-sub-item fs-12 d-block ml-3 font-weight-bold"
                      :to="{ name: 'editar-imagens-produto-app' }"
                      >&#9679; Produtos App</router-link
                    >
                  </li>
                </div>
              </transition>
            </li>
          </ul>

          <ul v-if="checkPermission('ranking')" id="ranking" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.whatsapp.open = !menu.whatsapp.open">
                <i class="fab fa-whatsapp"></i>
                <span class="d-none d-sm-inline"> WhatsApp</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.whatsapp.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.whatsapp.open">
                  <ul class="flex-column ml-3 nav">
                    <li class="sub-item font-weight-bold">
                      <router-link
                        class="dropdown-sub-item fs-12"
                        :to="{ name: 'administrador-whatsapp' }"
                        >&#9679; Enviar mensagem</router-link
                      >
                    </li>
                    <li class="sub-item font-weight-bold">
                      <router-link
                        class="dropdown-sub-item fs-12"
                        :to="{ name: 'administrador-disparar-whatsapp' }"
                        >&#9679; Disparar mensagens para
                        profissionais</router-link
                      >
                    </li>
                    <li class="sub-item font-weight-bold">
                      <router-link
                        class="dropdown-sub-item fs-12"
                        :to="{
                          name: 'administrador-construp-notificacoes-whatsapp',
                        }"
                        >&#9679; Conectcar WhatsApp</router-link
                      >
                    </li>
                  </ul>
                </div>
              </transition>
            </li>
          </ul>
          <ul v-if="checkPermission('ranking')" id="ranking" class="slide-nav">
            <li class="nav-item mr-2 mb-3">
              <div @click="menu.contatos.open = !menu.contatos.open">
                <i class="fas fa-address-book"></i>
                <span class="d-none d-sm-inline"> Contatos Clientes</span>
                <i
                  :class="
                    'ml-2 fas ' +
                    [
                      !menu.contatos.open
                        ? 'fa-chevron-right'
                        : 'fa-chevron-down',
                    ]
                  "
                ></i>
              </div>
              <transition name="fade">
                <div v-show="menu.contatos.open">
                  <ul class="flex-column ml-3 nav">
                    <li class="sub-item font-weight-bold">
                      <router-link
                        class="dropdown-sub-item fs-12"
                        :to="{ name: 'administrator-contact' }"
                        >&#9679; Tabela de contatos</router-link
                      >
                    </li>
                  </ul>
                </div>
              </transition>
            </li>
          </ul>

          <Topic class="mt-4" text="Cache" icon="fas fa-soap" />
          <b-button class="mt-2" variant="warning" @click="cleanCache()">
            <span class="mr-2">Limpar Cache</span> <i class="fas fa-soap"></i>
          </b-button>

          <Topic class="mt-4" text="Site de profissionais" icon="fas fa-cog" />
          <Item
            icon="fas fa-hand-paper"
            pushToRouteName="administrador-profissional-site"
            itemText="Solicitações"
            hideCountBadge
          />

          <Topic class="mt-4" text="App de lojistas" icon="fas fa-cog" />
          <Item
            icon="fas fa-hand-paper"
            pushToRouteName="administrador-lojistas-app"
            itemText="Solicitações"
            hideCountBadge
          />
          <Item
            icon="fas fa-mobile"
            pushToRouteName="administrador-version-app"
            itemText="Versão App"
            hideCountBadge
          />
          <Item
            icon="fas fa-clipboard-check"
            pushToRouteName="administrador-lojistas-app-pedidos"
            itemText="Pedidos"
            hideCountBadge
          />
          <Item
            icon="fas fa-recycle"
            pushToRouteName="administrador-lojistas-app-status-pedidos"
            itemText="Status dos pedidos"
            hideCountBadge
          />
          <Item
            icon="fas fa-dice"
            pushToRouteName="administrador-app-sorteios"
            itemText="Sorteios"
            hideCountBadge
          />
          <Item
            icon="fas fa-users"
            pushToRouteName="administrador-lojistas-app-clientes"
            itemText="Clientes e profissionais"
            hideCountBadge
          />
          <Item
            icon="fas fa-check-double"
            pushToRouteName="administrador-lojistas-app-produtos-preco"
            itemText="Produtos com preço"
            hideCountBadge
          />
          <Item
            icon="fas fa-box"
            pushToRouteName="administrador-lojistas-excluir-foto-produto"
            itemText="Excluir fotos do produto"
            hideCountBadge
          />
          <Item
            icon="fas fa-file-import"
            pushToRouteName="administrador-lojistas-app-arquivos-importacao"
            itemText="Arquivos para importação"
            hideCountBadge
          />
          <Item
            icon="fas fa-file-excel"
            pushToRouteName="administrador-lojistas-app-importar-excel"
            itemText="Importar produtos Excel"
            hideCountBadge
          />
          <Item
            icon="fas fa-users"
            pushToRouteName="administrador-importar-clients-excel"
            itemText="Importar clientes Excel"
            hideCountBadge
          />
          <!-- produtos sugeridos -->
          <Item
            icon="fas fa-shopping-cart"
            pushToRouteName="administrador-lojistas-app-produtos-sugeridos"
            itemText="Produtos sugeridos"
            hideCountBadge
          />
          <Item
            icon="fas fa-box-open"
            pushToRouteName="administrador-lojistas-app-produtos-aprovacao"
            itemText="Produtos aprovação"
            hideCountBadge
          />
          <Item
            icon="fas fa-boxes"
            pushToRouteName="administrador-editar-lojista-produto"
            itemText="Editar lojista do produto"
            hideCountBadge
          />
          <Item
            icon="fas fa-edit"
            pushToRouteName="administrador-lojistas-editar-produtos"
            itemText="Editar produtos"
            hideCountBadge
          />
          <Item
            icon="fas fa-id-card-alt"
            pushToRouteName="list-request-withdraw"
            itemText="Solicitação saque"
            hideCountBadge
          />
          <Item
            icon="fab fa-whatsapp"
            pushToRouteName="administrador-app-notificacoes-whatsapp"
            itemText="Notificação WhatsApp"
            hideCountBadge
          />
          <Item
            icon="fas fa-comment-dots"
            pushToRouteName="administrador-enviar-whatsapp-excel"
            itemText="Enviar WhatsApp Excel"
            hideCountBadge
          />
          <Item
            icon="fas fa-microphone"
            pushToRouteName="administrador-enviar-whatsapp-audio"
            itemText="Enviar WhatsApp Audio"
            hideCountBadge
          />
          <Item
            icon="fab fa-whatsapp"
            pushToRouteName="administrador-conversas-whatsapp"
            itemText="Ver Conversas WhatsApp"
            hideCountBadge
          />
          <Item
            icon="fas fa-robot"
            pushToRouteName="administrador-app-construbot-whatsapp"
            itemText="Desativar ConstruBot"
            hideCountBadge
          />
          <Item
            icon="fas fa-comments"
            pushToRouteName="administrador-app-configs"
            itemText="Configs"
            hideCountBadge
          />
          <Item
            icon="fas fa-user-shield"
            pushToRouteName="administrador-impersonate"
            itemText="Acesso a usuários"
            hideCountBadge
          />
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 col-12 p-0">
        <div class="conteudo-area-restrita mt-0" style="min-height: 100vh">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import Item from 'Components/Menu/Item.vue';
import Topic from 'Components/Menu/Topic.vue';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import makeToast from '@/mixins/makeToast';

export default {
  name: 'administrador',
  mixins: [makeToast],
  computed: {
    ...mapState(['token', 'dadosUsuario']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
  },
  data: () => ({
    isSlowDados: true,
    menu: {
      users: {
        open: false,
      },
      plans: {
        open: false,
      },
      banners: {
        open: false,
      },
      measures: {
        open: false,
      },
      states: {
        open: false,
      },
      citys: {
        open: false,
      },
      segments: {
        open: false,
      },
      professions: {
        open: false,
      },
      products: {
        open: false,
      },
      appReq: {
        open: false,
      },
      brands: {
        open: false,
      },
      blog: {
        open: false,
      },
      planorders: {
        open: false,
      },
      reports: {
        open: false,
      },
      quotes: {
        open: false,
      },
      ranking: {
        open: false,
      },
      videos: {
        open: false,
      },
      imagens: {
        open: false,
      },
      whatsapp: {
        open: false,
      },
      contatos: {
        open: false,
      },
      email: {
        open: false,
      },
      app: {
        open: false,
      },
      balconista: {
        open: false,
      },
    },
  }),
  methods: {
    // Checar se o ADM tem permissão para aquele conteúdo
    checkPermission(option, subitem = '') {
      // Array de permissões do ADM
      let permissoes_array = this.dadosUsuario.permissoes;
      permissoes_array = JSON.parse(permissoes_array);

      // Caso seja o ADM Geral (adauto hehe)
      // Retornaremos true para tudo, sem precisar comparar
      if (permissoes_array.hasOwnProperty('*')) return true;

      if (subitem != '') {
        if (permissoes_array[option].includes(subitem)) {
          return true;
        }
        return false;
      }

      // Caso o ADM tenha permissão
      if (permissoes_array.hasOwnProperty(option)) return true;

      return false;
    },

    async cleanCache() {
      await shopkeeperAppApi.get('/clean-cache');

      this.makeToast('Sucesso', `Cache limpo com sucesso`, 'success');
    },
  },
  components: {
    Item,
    Topic,
  },
};
</script>
<style scoped>
.nav-link[data-toggle]:hover.collapsed:before {
  content: ' ▾';
}

.nav-link[data-toggle]:hover:not(.collapsed):before {
  content: ' ▴';
}
</style>
